exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-breadcrumb>li{display:inline-block}li.breadcrumb-item+li.breadcrumb-item:before{display:inline-block;font-family:FontAwesome;padding-right:.1rem;padding-left:.1rem;color:#51564b;content:\"\\F0DA\";font-size:1.1em}li.breadcrumb-item .btn.btn-primary{color:#fff}", ""]);

// exports
